export default "__VITE_PUBLIC_ASSET__18a594a7__"